export default __webpack_public_path__ + "1801b9b22cbbd37770ffafdfce38a464.png";